<template>
	<div class="app_box">
		<Htitle/>
		<TopNavbar />
		<Banner v-if="this.screenWidth > 1024"/>
		<!-- <Crumbs/> -->
		<PageLayout />
		
		<BackToTop />
		<Passenger />
		<Htitle/>
	</div>
</template>

<script>
import { MessageBox } from 'element-ui'
import Htitle from './components/public/Htitle.vue'
import Crumbs from './components/public/Crumbs.vue'
import TopNavbar from './components/TopNavbar.vue'
import Banner from './components/Banner.vue'
import PageLayout from './components/PageLayout.vue'
import BackToTop from './components/suspension/BackToTop.vue'
import Passenger from './components/suspension/Passenger.vue'
import { post_community_userinfo, post_community_login } from '@/api/community.js'

export default {
	name: 'App',
	components: { Htitle, TopNavbar, Banner, PageLayout, BackToTop, Passenger, Crumbs },
	
	data() {
		return {
			
		}
	},
	
	computed: {
		screenWidth() {
			return this.$sharedState.screenWidth;
		},
	},

	// 监听
	watch: {
		// "answer": {
		// 	handler: function (newValue, oldValue) {
		// 		this.selectionItems()
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
	//   compPath = this.$store.state.isPcDevice ? 'CustomerServicePc.vue' : 'CustomerServiceM.vue'
	// }
	
	beforeDestroy() {
	   // 移除窗口大小改变的监听器
	   window.removeEventListener('resize', this.handleResize);
	},
	
	created () {
		this.get_lang_id()
		this.get_cookie()
	},
	
	beforeUnmount() {
	   window.removeEventListener('resize', this.handleResize);
	   // 移除 script 元素（可选）
	   const script = document.querySelector(`script[src^="//helps.live/webim/en-US/easemob.js?configId=5c8b614f-8d90-4060-88f1-673d508301d5"]`);
	   if (script) {
	      document.body.removeChild(script);
	   }
	},
  
	mounted() {
		console.log(this.$IsConfirmExecute)
		this.listenIn_tab()
		this.get_cookie_expired()
		// this.get_cookie()
		this.get_lang_id()
		// 在窗口大小改变时更新 screenWidth
		this.handleResize()
		window.addEventListener('resize', this.handleResize);
		
		this.$nextTick(() => {
			this.set_message_input()
		})
		// 点击上传区域后延迟重新赋值
		this.$el.addEventListener('click', () => {
			this.set_message_input()
		})
	},
  
	methods:{
		set_message_input(){
			setTimeout(() => {
				// 全局body下查找弹窗输入框，修正class选择器前缀.
				const msgInput = document.querySelector('.el-message-box__input .el-input__inner')
				if (msgInput) {
					msgInput.setAttribute('aria-label', 'Message text input field')
				}
			}, 100)
		},
		
		customer_service(){
			// 动态创建 script 元素
			const script = document.createElement('script');
			script.src = `//helps.live/webim/en-US/easemob.js?configId=5c8b614f-8d90-4060-88f1-673d508301d5&language=${this.$language}`;
			script.defer = true;
			document.body.appendChild(script);
		},
		
		listenIn_tab(){
			// 创建监听浏览器切换窗口
			document.addEventListener('visibilitychange', () => {
				if(document.visibilityState === 'hidden') { // 离开当前tab标签
					console.log('1')
					// 暂停视频
				}else {
					// 播放视频
					// console.log('回到当前tab标签')
					this.get_cookie_expired()
					// this.get_cookie()
				}
			})
		},
		
		// 获取 cookie 的函数是否过期
		get_cookie_expired() {
		   let decodedCookies = {};
		   let cookieValue = document.cookie;
		   if (cookieValue && cookieValue.length!== 0) {
		      cookieValue.split(';').forEach(cookie => {
		         let parts = cookie.split('=');
		         let key = decodeURIComponent(parts[0].trim()); 
		         let value = decodeURIComponent(parts[1]);
		         decodedCookies[key] = value;
		      });
				let that = this
				function refresh_fun(){
					// 检查 DIV_authentication 的过期时间
					// let divAuthExpires = that.checkExpiry('DIV_authentication', decodedCookies);
					let session_key = decodedCookies.DIV_authentication
					console.log(session_key)
					if (session_key) {
						let DIV_authentication_expire = decodedCookies.DIV_authentication_expire
						let refresh = true
						if(DIV_authentication_expire){
							const new_expire = DIV_authentication_expire;
							const currentTime = Math.floor(Date.now() / 1000); // 获取当前时间戳（秒）
							if (currentTime > new_expire) {
								refresh = false
								console.log("中心过期");
							} else {
								refresh = true
								console.log("中心期间");
							}
						}
						
						if(session_key && session_key != 'undefined' && session_key != '' && refresh){
						  that.post_community_login(session_key)
						}
					} else {
						// that.LoginTips()
						that.$cookie.delete('login_token') //社区接口的token
						that.$cookie.delete('login_token_expire') //社区接口的token 过期时间
						that.$cookie.delete('token') //官网接口的token
						that.$cookie.delete('DIV_authentication') //获取token的key
						that.$cookie.delete('DIV_authentication_expire') //获取token的过期时间
						that.$cookie.delete('user')
					   console.log('中心过期');
					}
				}
				
		      // 检查 社区token 的过期时间
		      let login_token = decodedCookies.login_token
		      let login_token_expire = decodedCookies.login_token_expire
		      // let login_token = this.checkExpiry('login_token', decodedCookies);
		      // let login_token_expire = this.checkExpiry('login_token_expire', decodedCookies);
				console.log(login_token);
				console.log(login_token_expire);
				
				if(login_token){
					console.log("应用没过期");
					this.$store.state.userinfo.login_token = login_token
					this.getInfo(login_token)
				}else if (login_token_expire) {
					const new_expire = login_token_expire - 3600; // 减去1小时（3600秒）
					const currentTime = Math.floor(Date.now() / 1000); // 获取当前时间戳（秒）
					if (currentTime > new_expire) {
						refresh_fun()
						console.log("应用即将过期");
					} else {
						refresh = false
						console.log("应用期间");
					}
		      } else {
					console.log("应用过期");
		         refresh_fun()
		      }
		   }
		},
		
		checkExpiry(cookieName, cookies) {
		   let expiry = null;
		   let cookieStr = cookies[cookieName];
		   if (cookieStr) {
		      // 查找 expires 属性
		      let expiresIndex = cookieStr.indexOf('expires=');
		      if (expiresIndex!== -1) {
		         let expiresStr = cookieStr.substring(expiresIndex + 8); // 提取 expires 的值
		         let expiresDate = new Date(expiresStr);
		         let currentDate = new Date();
		         if (expiresDate > currentDate) {
		            expiry = true;
		         }
		      } else {
		         // 查找 max-age 属性
		         let maxAgeIndex = cookieStr.indexOf('max-age=');
		         if (maxAgeIndex!== -1) {
		            let maxAgeStr = cookieStr.substring(maxAgeIndex + 8);
		            let maxAge = parseInt(maxAgeStr);
		            let currentTime = Date.now();
		            let expiryTime = currentTime + (maxAge * 1000);
		            if (expiryTime > currentTime) {
		               expiry = true;
		            }
		         }
		      }
		   }
		   return expiry;
		},
		
		// 去登录
		goLigin(){
			this.$router.push({
			   name: "login",
			   params: {}
			})
		},
		
		// 登录提示
		LoginTips(){
			if(this.$IsConfirmExecute) { return }
			this.$IsConfirmExecute = true
			MessageBox.confirm(
			   this.$t('ConfirmPrompt.Your_login'),
			   this.$t('ConfirmPrompt.Login_Tips'),
			   {
			      confirmButtonText: this.$t('buttonArr.Confirm'),
			      cancelButtonText: this.$t('buttonArr.Cancel'),
			      type: 'warning',
			   }
			).then((res) => {
				try {
				   // 用户点击了确认按钮
				   this.goLigin()
					console.log("用户点击了确认按钮")
				} catch (error) {
				   console.error('Error in then block:', error);
				}
				this.$IsConfirmExecute = false
			}).catch((err) => {
			   // 用户点击了取消按钮
				this.$IsConfirmExecute = false
				console.log("用户点击了取消按钮")
			});
			// 主动调用根组件的无障碍修复方法
  			this.$root.set_message_input()
		},
		
		//暂无用
		get_cookie(){
			// let cookieValue = decodeURIComponent(document.cookie); //decodeURIComponent反转译
			// let encodeURIComponent_ = encodeURIComponent(document.cookie); //decodeURIComponent转译
			let decodedCookies = {};
			let cookieValue = document.cookie;
			if(cookieValue && cookieValue.length != 0){
					cookieValue.split(';').forEach(cookie => {
					let parts = cookie.split('=');
					let key = decodeURIComponent(parts[0].trim()); //decodeURIComponent反转译
					let value = decodeURIComponent(parts[1]);
					decodedCookies[key] = value;
				});
				let login_token = decodedCookies.login_token
				if(!login_token){
					let session_key = decodedCookies.DIV_authentication
					if(session_key && session_key != 'undefined' && session_key != ''){
					this.post_community_login(session_key)
					}else{
						// this.LoginTips()
					}
				}else{
					this.$store.state.userinfo.login_token = login_token
					this.getInfo(login_token)
				}
			}else{
			  	// this.LoginTips()
			}
		},
		
		//登录
		post_community_login(session_key){
			if(this.Loading){ return }
			this.Loading = true
			post_community_login({session_key: session_key})
		   .then((res) => {
				console.log(res)
				this.Loading = false
				if(res.code == 0){
					let login_token = res.data.token
					let token_expire = res.data.token_expire
					// 使用 Math.floor() 和 Date.now() 方法获取当前时间戳（秒）
					let timestampInSeconds = Math.floor(Date.now() / 1000);
					let Expired = Number(timestampInSeconds)+Number(token_expire)
					this.$cookie.set('login_token', login_token, { expires: '7D' })
					this.$cookie.set('login_token_expire', Expired, { expires: '7D' })
					this.$store.state.userinfo.login_token = login_token
					this.getInfo(login_token)
				}else{
					this.exception_handling(res)
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err)
		   })
		},
		
		
		//获取用户信息
		getInfo(login_token){
			if(this.Loading){ return }
			post_community_userinfo()
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					let response = res.data
					response.login_way = 'local'
					response.login_token = login_token
					this.$cookie.set('user', JSON.stringify(response), { expires: '7D' })
					this.$store.dispatch('userinfo', [response, this])
					this.$store.commit('changeUserinfo', Object.assign({}, this.$store.state.userinfo, response))
					console.log(this.$route)
					if(this.$route.query.redirect){
					  this.$router.push({ path: this.$route.query.redirect})
					}else if(this.$route.fullPath){
						this.$router.push({ name: this.$route.name})
					}else{
					  this.$router.push({ name: "home"})
					}
				}else{
					this.exception_handling(res)
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err)
		   })
		},
		
		//异常处理
		exception_handling(err){
			this.Loading = false
			this.$errorMessage(err)
			// this.$message('err.data.message', 'error')
		},
		
		// 获取屏幕宽度
		handleResize() {
			this.$screenWidth = window.innerWidth;
		},
		
		get_cookie_name(name){
			let decodedCookies = {};
			let cookieValue = document.cookie;
			if(cookieValue && cookieValue.length != 0){
					cookieValue.split(';').forEach(cookie => {
					let parts = cookie.split('=');
					let key = decodeURIComponent(parts[0].trim()); //decodeURIComponent反转译
					let value = decodeURIComponent(parts[1]);
					decodedCookies[key] = value;
				});
				return decodedCookies[name]
			}else{
			  	return null
			}
		},
		
		get_lang_id() {
			let lang_id; // 默认语言

			// 确保 this.$route 存在
			if (this.$route && this.$route.query) {
				// let redirectUrl = this.$route.query?.redirect_url;
				// console.log(redirectUrl)
				// if (redirectUrl && redirectUrl.includes('http')) {
				// 	try {
				// 		const url = new URL(redirectUrl);  // 创建 URL 对象
				// 		lang_id = url.pathname.split('/')[1];  // 获取第一个路由部分作为语言
				// 		console.log('Redirect URL lang_id:', lang_id);  // 调试
				// 	} catch (error) {
				// 		console.error('Error parsing redirect_url:', error);
				// 	}
				// }

			  // 如果没有通过 redirect_url 获取语言，再从 locale 获取
			  if (!lang_id || lang_id === 'en') {
				 let locale = this.$route.query?.locale;
				 if (locale) {
					lang_id = locale.split('-')[0];  // 提取 locale 中的语言部分
					console.log('Locale lang_id:', lang_id);  // 调试
				 }
			  }
			}

			// 确保 lang_id 是有效的语言代码
			let lang_list = ['en', 'es', 'ja', 'zh'];
			
			//本地缓存的
			let language = this.get_cookie_name('language')
			if(!lang_id){
				lang_id = language ? language : "en"
			} 
			
			lang_id = lang_id && lang_list.includes(lang_id) ? lang_id : 'en'; // 如果无效，则使用 'en'
			
			this.$cookie.set('language', lang_id, { expires: '366D' }) //366天

			// 设置 i18n 的语言
			this.$language = lang_id
			this.$i18n.locale = lang_id;
			return this.$i18n.locale;
		}
	}
}
</script>

<style lang="less" >
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.app_box{
		width: 100%;
		height: 100%;
		min-height: 100vh;
	}
	@media screen and (min-width: 1024px) {
		.app_box{
			width: 100%;
			height: 100%;
			min-height: 100vh;
			background-color: #f6f6f6;
			padding-top: 80px;
	  }
	}
	@media screen and (max-width: 1024px) {
		.app_box{
			width: 100%;
			height: 100%;
			min-height: 100vh;
			background-color: #f6f6f6;
			/* background-color: #ffffff; */
			padding-top: 50px;
		}
	}
	@media screen and (max-width: 450px) {
	  .el-notification {
		 width: 90%;
	  }
	}
	.el-message-box__wrapper{
		z-index: 99999999 !important;
	}
	.el-message-box .el-message-box__btns .el-button--primary {
		background: #06f !important;
	}
</style>
